<template>
  <div style="margin: 20px">
    <el-card>
      <div slot="header" class="clearfix">
        <span>虚拟库存管理</span>
        <el-button
          type="primary"
          size="small"
          style="float: right; margin-left: 10px"
          @click="handleAdd"
        >
          新增虚拟库存
        </el-button>
      </div>

      <!-- 搜索栏 -->
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="4级分类">
          <el-input v-model="searchForm.type4" placeholder="请输入分类代码" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        v-loading="loading"
        border
        style="width: 100%"
        empty-text="暂无数据"
      >
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="type4" label="4级分类代码" width="150">
          <template slot-scope="scope">
            {{ scope.row.type4 || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="stock_num" label="虚拟库存数量" width="150" />
        <el-table-column prop="description" label="描述" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.description || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.updated_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleEdit(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px; text-align: right"
      />
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @close="handleDialogClose"
    >
      <el-form :model="form" :rules="rules" ref="dataForm" label-width="120px">
        <el-form-item label="4级分类代码" prop="type4">
          <el-input v-model="form.type4" placeholder="请输入4级分类代码，如：22010701" />
        </el-form-item>
        <el-form-item label="虚拟库存数量" prop="stock_num">
          <el-input-number
            v-model="form.stock_num"
            :min="0"
            :max="999999"
            placeholder="请输入虚拟库存数量"
          />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            v-model="form.description"
            type="textarea"
            :rows="3"
            placeholder="请输入描述信息（可选）"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getList, create, update, remove } from '@/api/virtualStock'

export default {
  name: 'VirtualStockManagement',
  data() {
    return {
      loading: false,
      searchForm: {
        type4: ''
      },
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增虚拟库存',
      isEdit: false,
      form: {
        id: null,
        type4: '',
        stock_num: 0,
        description: ''
      },
      rules: {
        type4: [
          { required: true, message: '请输入4级分类代码', trigger: 'blur' },
          { pattern: /^\d{8}$/, message: '必须是8位数字', trigger: 'blur' }
        ],
        stock_num: [
          { required: true, message: '请输入虚拟库存数量', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 获取列表数据
    async getData() {
      this.loading = true
      try {
        const res = await getList({
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        })
        console.log('虚拟库存列表响应:', res) // 调试日志
        // 后端返回格式: { error: 0, message: "", data: { list: [...], total: 123, page: 1, pageSize: 20 } }
        // res.data 是后端返回的整个JSON对象
        // res.data.data 才是 data 字段
        if (res.data && res.data.error === 0) {
          // res.data.data 是 { list: [...], total: 123, page: 1, pageSize: 20 }
          this.tableData = res.data.data?.list || []
          this.pagination.total = res.data.data?.total || 0
          console.log('处理后的数据:', this.tableData) // 调试日志
        } else {
          this.$message.error(res.data?.message || '获取数据失败')
        }
      } catch (error) {
        console.error('获取数据异常:', error)
        this.$message.error(error.message || '获取数据失败')
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.page = 1
      this.getData()
    },

    // 重置
    handleReset() {
      this.searchForm = {
        type4: ''
      }
      this.pagination.page = 1
      this.getData()
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.page = 1
      this.getData()
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.page = val
      this.getData()
    },

    // 新增
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增虚拟库存'
      this.form = {
        id: null,
        type4: '',
        stock_num: 0,
        description: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm && this.$refs.dataForm.clearValidate()
      })
    },

    // 编辑
    handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑虚拟库存'
      this.form = {
        id: row.id,
        type4: row.type4,
        stock_num: row.stock_num,
        description: row.description
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm && this.$refs.dataForm.clearValidate()
      })
    },

    // 删除
    handleDelete(row) {
      this.$confirm('确定要删除该虚拟库存设置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await remove(row.id)
          this.$message.success('删除成功')
          this.getData()
        } catch (error) {
          this.$message.error(error.message || '删除失败')
        }
      }).catch(() => {})
    },

    // 提交表单
    handleSubmit() {
      this.$refs.dataForm.validate(async (valid) => {
        if (!valid) return

        try {
          if (this.isEdit) {
            await update(this.form.id, this.form)
            this.$message.success('更新成功')
          } else {
            await create(this.form)
            this.$message.success('创建成功')
          }
          this.dialogVisible = false
          this.getData()
        } catch (error) {
          this.$message.error(error.message || '操作失败')
        }
      })
    },

    // 对话框关闭
    handleDialogClose() {
      this.$refs.dataForm && this.$refs.dataForm.resetFields()
    },

    // 格式化时间
    formatTime(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.search-form {
  margin-bottom: 20px;
}
.dialog-footer {
  text-align: right;
}
</style>
